import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import PropagateLoader from "react-spinners/PropagateLoader";
import { useFormik } from 'formik';
import { AddFolderSchema } from './FileLibrarySchema';
import { useDispatch, useSelector } from 'react-redux';
import { addUpdateFolderRes, addUpdateFolderTodo } from '../../LMS_Redux/LMS_Slices/FileLibrary/AddUpdateFolder';
import { ToastContainer, toast } from 'react-toastify';
import { folderListRes, folderListTodo } from '../../LMS_Redux/LMS_Slices/FileLibrary/FolderList';
import { FaTrash } from 'react-icons/fa6';
import { IoMdFolder } from "react-icons/io";
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import { deleteFolderRes, deleteFolderTodo } from '../../LMS_Redux/LMS_Slices/FileLibrary/DeleteFolder';
import { Spinner } from 'react-bootstrap';

export default function FileLibrary() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.folderList && state.folderList.data && state.folderList.data.data)
    const [loading, setLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [bool, setBool] = useState(false)
    const [folder, setFolder] = useState(false)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const initialValues = {
        folder_name: '',
        folder_desc: '',
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: AddFolderSchema,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addUpdateFolderTodo(values)).then(() => add_update_res())
        },
    })

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'TITLE',
            field: 'folder_name',
            cellRenderer: (params) =>
                <div className='d-flex align-items-center' onClick={() => files_navigate(params)} style={{ cursor: 'pointer', lineHeight: '0.6' }}>
                    {/* <span className='folder' /> */}
                    <span><IoMdFolder size={50} style={{ color: '#2262C6' }} /></span> <br />
                    <span className='ms-1' style={{ color: '#2262C6', fontWeight: 'bold' }}>{params.value}</span>
                </div>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DESCRIPTION',
            field: 'description',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'SIZE',
            field: 'size',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        role == 'Instructor' ? null :
            {
                field: 'ACTIONS',
                cellRenderer: params =>
                    <div>
                        <FaTrash size={18} className='delete ms-3'
                            onClick={() => delete_folder(params)}
                            data-tooltip-id='delete'
                            data-tooltip-content="Delete Folder!"
                            data-tooltip-place="bottom"
                        />

                        <Tooltip id='delete' style={{ backgroundColor: "rgb(239, 61, 80)", zIndex: '9', lineHeight: 'normal' }} />
                    </div>,
                // wrapText: true,
                autoHeight: true,
            }
    ]);

    const delete_folder = (params) => {
        Swal.fire({
            title: 'Delete Folder',
            text: `Are you sure want to Delete Folder?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                // console.log(params.data)
                setLoading(true)
                dispatch(deleteFolderTodo(params.data.id)).then(() => del_folder_res())
            }
        })
    }

    const del_folder_res = () => {
        if (deleteFolderRes && deleteFolderRes.success) {
            Swal.fire(
                'Folder Status',
                deleteFolderRes.message,
                'success'
            )
            setBool(!bool)
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: deleteFolderRes.message,
            })
        }
    }

    const files_navigate = (params) => {
        navigate('/upload_files', { state: params.data })
    }

    const add_update_res = () => {
        // console.log(addUpdateQuizRes)
        if (addUpdateFolderRes && addUpdateFolderRes.success) {
            toast.success(addUpdateFolderRes.message, { position: "bottom-right" })
            setFolder(false)
            setBool(!bool)
            setSpinner(false)
        } else {
            toast.error(addUpdateFolderRes.message, { position: "bottom-right" })
            setFolder(false)
            setBool(!bool)
            setSpinner(false)
        }
    }

    const folder_list_res = () => {
        if (folderListRes && folderListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(folderListTodo()).then(() => folder_list_res())
    }, [bool])


    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>File Library / </span>
                    <span className='icon2'> Folder  </span>
                    {/* <span className='icon2'>Quiz List</span> */}
                </div>

                {role == 'Instructor' ? '' :
                    <div className='text-end mb-3'>
                        <button className='btn btn_submit' type='button' onClick={() => setFolder(true)}>Add Folder</button>
                    </div>
                }

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={data}
                        columnDefs={columnDefs.filter((colDef) => colDef !== null)}
                        height={'60vh'}
                        rowHeight={50}
                    />
                }
            </div>

            <div className={folder ? 'modal fade show d-block' : 'modal fade show d-none'} style={{ background: 'rgba(0,0,0,0.8)' }} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Create Folder</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setFolder(false)}></button>
                        </div>
                        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">Folder Name</label>
                                    <input type="text" className="form-control form_input" placeholder="Title of Folder"
                                        name='folder_name' value={values.folder_name} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.folder_name && touched.folder_name ? (<span className='text-danger form_label'>{errors.folder_name}</span>) : null}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Description</label>
                                    <textarea className="form-control form_input" rows="1" placeholder="Folder Description"
                                        name='folder_desc' value={values.folder_desc} onChange={handleChange} onBlur={handleBlur}
                                    ></textarea>
                                    {errors.folder_desc && touched.folder_desc ? (<span className='text-danger form_label'>{errors.folder_desc}</span>) : null}
                                </div>
                            </div>
                            <div className="modal-footer">
                                {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                                <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                    {spinner ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='ms-2'
                                        />
                                        : ''
                                    }
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <ToastContainer />
        </>
    )
}